module.exports = __webpack_public_path__ + "img/kr-product-card3-item2-step2.6675d07.png";